"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setContentFragmentMap = exports.getDownloadListArrayById = exports.getContentFragmentById = exports.getContentArrayById = exports.getAccordionContentArrayById = exports.contentFragmentMap = exports.addDataAttrToLinks = void 0;
var ContentMethods = _interopRequireWildcard(require("./content"));
var _common = require("./common");
var _getLettersFromIndex = require("../utils/getLettersFromIndex");
var _object = require("../utils/type-checks/object");
var _string = require("../utils/type-checks/string");
var _array = require("../utils/type-checks/array");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let contentFragmentMap = exports.contentFragmentMap = [];

/**
 * Adds custom data injected indicator attribute to links in a content fragment
 *
 * @name addDataAttrToLinks
 * @param {string} contentFragmentStr Content fragment to edit
 * @returns {string} Transformed content fragment
 */
const addDataAttrToLinks = contentFragmentStr => {
  const regExp = /<a\s([\w-]+=".+?"\s)?(href+=".+?")(\s[\w-]+=".+?")?>/g;
  const regExpReplacement = `<a ${_common.HTML_DATA_ATTR_INJECTED}="true" $1$2$3>`;
  return (0, _string.isStringOfLength)(contentFragmentStr) ? contentFragmentStr.replace(regExp, regExpReplacement) : contentFragmentStr;
};

/**
 * Retrieves fragment object from content fragment array
 *
 * @name getContentFragmentById
 * @param {string} id String identifying content fragment in content fragment map
 * @returns {string} Content fragment object from content fragment map (if successful)
 */
exports.addDataAttrToLinks = addDataAttrToLinks;
const getContentFragmentById = id => {
  try {
    if ((0, _array.isArrayOfLength)(contentFragmentMap)) {
      const fragmentObj = contentFragmentMap.find(fragment => fragment.id === id);
      if ((0, _object.isObject)(fragmentObj)) {
        return ContentMethods.addDataAttrToLinks(fragmentObj.fragment);
      } else {
        throw new Error(`Content fragment ${id} not found in mapping.`);
      }
    } else {
      throw new Error("No Content Fragments in map. Add some Content Fragments, or invoke the setter pre-render.");
    }
  } catch (e) {
    console.error(e);
    return null;
  }
};

/**
 * Setter for contentFragmentMap variable
 *
 * @name setContentFragmentMap
 * @param {array} [map=[]] Array to set as new content fragment map
 * @returns {array} New content fragment map array
 */
exports.getContentFragmentById = getContentFragmentById;
const setContentFragmentMap = function () {
  let map = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if ((0, _array.isArray)(map)) {
    exports.contentFragmentMap = contentFragmentMap = map;
  } else {
    console.error("Could not set Content Fragment Map: Invalid Argument 'map'.");
  }
  return contentFragmentMap;
};
exports.setContentFragmentMap = setContentFragmentMap;
const getAccordionContentArrayById = id => {
  return ContentMethods.getContentArrayById(id).map((item, index) => {
    if (!item.fragmentId && !item.linkId && !item.customId) {
      return {
        ...item,
        fragmentId: `${(0, _getLettersFromIndex.getLettersFromIndex)(index)}-${id}`
      };
    } else {
      return item;
    }
  });
};
exports.getAccordionContentArrayById = getAccordionContentArrayById;
const getContentArrayById = id => {
  try {
    if ((0, _array.isArrayOfLength)(contentFragmentMap)) {
      const fragmentObject = contentFragmentMap.find(fragment => fragment.id === id);
      if ((0, _object.isObject)(fragmentObject)) {
        if ((0, _array.isArrayOfLength)(fragmentObject.fragment)) {
          return fragmentObject.fragment.map(item => {
            return {
              ...item.metaData,
              content: ContentMethods.addDataAttrToLinks(item.content)
            };
          });
        } else {
          return [];
        }
      } else {
        throw new Error(`Content fragment ${id} not found in mapping.`);
      }
    } else {
      throw new Error("No Content Fragments in map. Add some Content Fragments, or invoke the setter pre-render.");
    }
  } catch (e) {
    console.error(e);
    return false;
  }
};
exports.getContentArrayById = getContentArrayById;
const getDownloadListArrayById = id => {
  let fileList = ContentMethods.getContentArrayById(id),
    newList;
  if ((0, _array.isArrayOfLength)(fileList)) {
    newList = fileList.map(item => ({
      ...item,
      isNewWindow: (0, _string.isStringOfLength)(item.isNewWindow) ? item.isNewWindow.toLowerCase() === "true" : item.isNewWindow
    }));
  }
  return newList ? newList : fileList;
};
exports.getDownloadListArrayById = getDownloadListArrayById;